import { Injectable } from '@angular/core';
import { IContactExecuteItem, IContactInitDisplaySetting, IEmployee, ILoginUserEmployeeBindModel } from '@blcloud/bl-datamodel';
import { CommonConst } from '@blcloud/bl-datamodel/const/common';
import { LogicalDeleteDiv } from '@blcloud/bl-datamodel/enum/common/logical-delete-div';
import { BlApiErrorInfo, BlConditionType, HttpStatus } from '@blcloud/bl-ng-common';
import { ContactExecuteItemResource, ContactInitDisplaySettingResource } from '@blcloud/bl-ng-resource';
import { EmployeeResourceService, LoginResourceService } from '@blcloud/bl-ng-share-module';
import { cloneDeep as _cloneDeep } from 'lodash';
import { Observable } from 'rxjs/Observable';
import { of as ObservableOf } from 'rxjs/observable/of';
import { _throw as ObservableThrow } from 'rxjs/observable/throw';
import { catchError, map } from 'rxjs/operators';
import { IContactInitDisplaySettingEx } from './contact-init-setting-modal.interface';

/**
 * コンタクト初期表示設定モーダルサービス
 */
@Injectable()
export class ContactInitSettingModalService {

  /**
   * コンストラクタ
   * @param
   */
  constructor(
    private employeeService: EmployeeResourceService,
    private contactInitDisplaySettingResource: ContactInitDisplaySettingResource,
    private loginResourceService: LoginResourceService,
    private contactExecuteItemResource: ContactExecuteItemResource,
  ) { }

  /**
   * ログインユーザー情報取得
   */
  getLoginUserEmployeeBindModel(): Observable<ILoginUserEmployeeBindModel> {
    return this.loginResourceService.getLoginUserEmployeeBindModel();
  }

  /**
   * コンタクト初期表示設定
   * @param id　employeeCode
   */
  getContactInitDisplaySetting(id: string): Observable<IContactInitDisplaySetting | null> {
    return this.contactInitDisplaySettingResource.getById<IContactInitDisplaySetting>(id).pipe(
      catchError((error: BlApiErrorInfo) => {
        if (error.status === HttpStatus.NotFound) {
          return ObservableOf(null);
        } else {
          return ObservableThrow(error);
        }
      })
    );
  }

  /**
   * コンタクト初期表示設定を削除します。
   * @param contactInitDisplaySettingEx　拡張コンタクト初期表示設定
   */
  deleteContactInitDisplaySetting(contactInitDisplaySettingEx: IContactInitDisplaySettingEx): Observable<IContactInitDisplaySetting> {
    const contactInitDisplaySetting: IContactInitDisplaySetting = _cloneDeep(contactInitDisplaySettingEx);
    if (!contactInitDisplaySettingEx.isRegist) {
      return this.contactInitDisplaySettingResource.deleteByEntity<IContactInitDisplaySetting>(contactInitDisplaySetting);
    } else {
      return ObservableOf(null);
    }
  }

  /**
   * 従業員コードから従業員を取得します
   * @param code　従業員コード
   */
  getEmployee(code: string): Observable<IEmployee> {
    const id = this.employeeService.getIdString({
      companyMgtCode: CommonConst.COMPANY_MGT_CODE_OWN_COMPANY,
      employeeCode: code
    });

    return this.employeeService.getById<IEmployee>(id).pipe(
      catchError((error: BlApiErrorInfo) => {
        if (error.status === HttpStatus.NotFound) {
          return ObservableOf(null);
        } else {
          return ObservableThrow(error);
        }
      })
    );
  }

  /**
   * コンタクト実施内容のセレクトボックス用データを取得する
   * @param orgCode 組織コード
   */
  getContactExecuteItem(orgCode: string): Observable<{ code: number, name: string, div: number }[]> {
    // 検索条件
    const conditions = [
      {
        key: 'organizationCode',
        value: orgCode,
        type: BlConditionType.Equal
      },
      {
        key: 'logicalDeleteDiv',
        value: LogicalDeleteDiv.Valid,
        type: BlConditionType.Equal
      }];
    // ソート条件
    const sortFields = [
      { field: 'contactExecuteItemDispOrder', desc: false }
    ];

    return this.contactExecuteItemResource.getAll<IContactExecuteItem>({ conditions, sortFields }).pipe(
      map(res => {
        const list = res ? res.searchResultList : [];

        return list.map(contactExecuteItem => {
          // グループ区分が3以上の場合3にする
          const groupDiv = (3 <= contactExecuteItem.contactItem.contactCheckDiv) ? 3 : contactExecuteItem.contactItem.contactCheckDiv;
          return { code: contactExecuteItem.contactExecuteItemCode, name: contactExecuteItem.contactExecuteItem,
            div: groupDiv };
        });
      }),
      catchError((error: BlApiErrorInfo) => {
        if (error.status === HttpStatus.NotFound) {
          return ObservableOf([]);
        } else {
          return ObservableThrow(error);
        }
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/contact-init-setting/contact-init-setting-modal.service.ts